import { render, staticRenderFns } from "./rule-font.vue?vue&type=template&id=49e26023&scoped=true&"
import script from "./rule-font.vue?vue&type=script&lang=js&"
export * from "./rule-font.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e26023",
  null
  
)

export default component.exports